import { Box, Flex, Grid, Text, useTheme } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

import { RoutesEnum } from '@/enums/routes.enum';

import { useNavLinks } from '@/hooks/useNavLinks.hook';
import { useSettings } from '@/hooks/useSettings.hook';

import { Logo } from '../Common/Logo';

export const SidebarNavbar = () => {
  const theme = useTheme();
  const { isMobile } = useSettings();
  const { sidebarNavLinks } = useNavLinks();

  return (
    <Flex
      align='center'
      bgColor={theme.colors.desktopSideNavbar.bg}
      color='white'
      flexDirection={isMobile ? 'column' : 'row'}
      justify='center'
      sx={
        !isMobile
          ? {
              height: '100vh',
              maxH: '800px',
              top: '0',
              left: '0',
              position: 'fixed',
              width: '112px',
            }
          : undefined
      }
      zIndex={100}
    >
      {
        <Flex
          align='center'
          as={NavLink}
          justify='center'
          p='10px'
          position={isMobile ? 'relative' : 'absolute'}
          to={RoutesEnum.home}
          top={isMobile ? '10px' : '40px'}
          w='100%'
        >
          <Logo />
        </Flex>
      }
      <Grid
        color='white'
        gap='10px'
        sx={
          !isMobile
            ? { gridTemplateRows: `repeat(${sidebarNavLinks.length}, 1fr)` }
            : { gridTemplateColumns: `repeat(${sidebarNavLinks.length}, 1fr)` }
        }
      >
        {sidebarNavLinks.map((item) => (
          <Flex
            align='center'
            as={NavLink}
            color={
              item.selected
                ? theme.colors.desktopSideNavbar.textActive
                : theme.colors.desktopSideNavbar.text
            }
            justify='center'
            key={item.linkData.to as string}
            {...item?.linkData}
          >
            <Flex
              align='center'
              direction='column'
              justify='center'
              padding='10px'
            >
              {item?.renderIcon && (
                <Box>
                  {item?.renderIcon({
                    fill: 'white',
                  })}
                </Box>
              )}
              <Text fontSize='12px' mt='5px' textAlign='center'>
                {item?.label}
              </Text>
            </Flex>
          </Flex>
        ))}
      </Grid>
    </Flex>
  );
};
